export default class Navigation {
  constructor() {
    this.state = {
      transform_prop: 'transform',
      transition_prop: 'transition',
      inner: document.getElementById('inner-wrap'),
      nav_open: false,
      current_nav: null,
    };

    this.init();
  }

  init() {
    // open nav with main "nav" button
    $('.js-toggle--nav').on('click', (e) => {
      this.toggleNav(e);
    });

    // open subnav
    $('.js-toggle--subnav').on('click', (e) => {
      this.toggleSubnav(e);
    });

    $('.mega-nav__link.dropdown-toggle').on('mouseup', (e) => {
      location.href = $(e.currentTarget).attr('href');
    });

    $('.write-a-review-link').on('keydown', function (e) {
      if (e.keyCode == 13 || e.keyCode == 32) {
        e.preventDefault();
        $('.write-a-review-link').trigger('click');
      }
    });
  }

  // helper functions
  closeNavEnd(e) {
    if (e && e.target === this.state.inner) {
      document.removeEventListener(this.transition_end(), this.closeNavEnd(), false);
    }

    this.state.nav_open = false;
  }

  closeNav(targetNav) {
    if (this.state.nav_open) {
      // close navigation after transition or immediately
      const duration =
        this.transition_end() && this.state.transition_prop
          ? parseFloat(window.getComputedStyle(this.state.inner, '')[this.state.transition_prop + 'Duration'])
          : 0;

      if (duration > 0) {
        document.addEventListener(this.transition_end(), this.closeNavEnd(), false);
      } else {
        this.closeNavEnd(null);
      }
    }
    $(targetNav).removeClass('active');
    this.state.current_nav = null;
  }

  openNav(targetNav) {
    if (this.state.nav_open) {
      return;
    }

    $(targetNav).addClass('active');
    this.state.nav_open = true;
    this.state.current_nav = targetNav;
  }

  toggleNav(e) {
    if (e) {
      e.preventDefault();
    }

    const targetNav = $(e.currentTarget).data('target');

    if (this.state.nav_open && $(targetNav).hasClass('active')) {
      this.closeNav(targetNav);
    } else {
      this.openNav(targetNav);
    }
  }

  toggleSubnav(e) {
    if (e) {
      e.preventDefault();
    }

    const targetSubnav = $(e.currentTarget).data('target');
    const currentNav = '#' + $(e.currentTarget).closest('nav').attr('id');

    if (targetSubnav != currentNav) {
      this.closeNav(this.state.current_nav);
      this.openNav(targetSubnav);
    } else {
      this.closeNav(targetSubnav);
      this.openNav(this.state.current_nav);
    }
  }

  transition_end() {
    let props = {
      WebkitTransition: 'webkitTransitionEnd',
      MozTransition: 'transitionend',
      OTransition: 'oTransitionEnd otransitionend',
      msTransition: 'MSTransitionEnd',
      transition: 'transitionend',
    };
    return props.hasOwnProperty(this.state.transition_prop) ? props[this.state.transition_prop] : false;
  }
}
